import styled from 'styled-components'
import { breakpoint } from 'utils'
import { rgba } from 'polished'

// Components
import { ButtonUnstyled } from 'components/Button'
import Panel from 'components/Panel'
import { ReactComponent as BaseSeat } from 'icons/seat.svg'
import { ReactComponent as BaseClock } from 'icons/clock-12.svg'

export const StyledPanelBody = styled(Panel.Body)``

export const StyledPanel = styled(Panel)`
  /* Sadly this was needed to fix the specificity of the padding CSS */
  ${StyledPanelBody} {
    padding-top: 20px;
    padding-bottom: 4px;
  }
`

export const StyledPanelTitle = styled(Panel.Title)`
  display: flex;
  padding-bottom: 20px;
  border-bottom: 1px solid ${({ theme }) => rgba(theme.colors.black, 0.06)};

  ${breakpoint('base', 'xs')`
    flex-direction: column;
    align-items: flex-start;

    & ${ButtonUnstyled} {
      margin-top: 16px;
    }
  `}

  /* Hack to fix the Button presentation in IE11 */
  & ${ButtonUnstyled} {
    flex-shrink: 0;
    display: inline;
  }
`

export const BodyWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const Paragraph = styled.p`
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.colors.scorpion};

  strong {
    color: ${({ theme }) => theme.colors.black};
  }
`

export const Seat = styled(BaseSeat)`
  width: 32px;
  height: 32px;
  margin-right: 10px; /* stylelint-disable-line scales/space */
`

export const StyledPanelFooter = styled(Panel.Footer)`
  text-align: left;
  font-size: 0.875rem;
  color: ${({ theme }) => theme.colors.scorpion};

  ${breakpoint('xs')`
    padding-left: 48px;
    padding-right: 48px;
  `}

  strong {
    font-weight: 400;
    color: ${({ theme }) => theme.colors.black};
  }
`

export const Clock = styled(BaseClock)`
  opacity: 0.5;

  width: 12px;
  height: 12px;

  /* work-around to center the Icon with the text */
  position: relative;
  top: 1px;
`
